import React from 'react'
import { Redirect as ReachRouterRedirect } from '@reach/router'
import { absolute } from '../../absolute_link'

export default function Redirect({to}) {
  return (
    <ReachRouterRedirect to={absolute(to)} noThrow/>
  )
}
